import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutDaviplataVoucherContainerComponent } from '@features/voucher/components/checkout-daviplata-voucher-container/checkout-daviplata-voucher-container.component';

/** Ruta legacy: mismo flujo que `VoucherComponent`. */
@Component({
  selector: 'app-daviplata-voucher-legacy',
  standalone: true,
  imports: [CommonModule, CheckoutDaviplataVoucherContainerComponent],
  template: '<checkout-daviplata-voucher-container />',
})
export class DaviplataVoucherComponent {}
